<script>
export default {
    name: "PrescriptionTab",

    data() {

        return {
            addTreatmentSheet: false,
            orderDrugs: false,
        };
    },

    props: {

        prescriptions: Array,
        noneDrugTreatments: Array,
        encounters: Array,
        patient: Object,
        visit: Object,
    },

    methods: {

      saveStopAdmin(prescription) {
          if(!window.confirm(`Confirm stop Administration`)) return;

          this.$root.loading = true;
          const presData = {
              prescriptionId: prescription.code,
              comment: ``,
              userName: this.$root.username,
          };

          return this.$http.post(`MedicalFile/StopPatientDrugTreatment`, presData).then(() => {
              this.$emit(`refresh`);
              this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
      },

      printMedicalFile() {
          window.print();
      },

      printTodaysPrescription() {
          let url = `/med-f-print/prescriptions-orders/print`;
              url += `/${this.$route.params.patientID}/${this.$route.params.visitNo}`;
  
          window.open(url, '_blank', `TodaysPrescription`,);
      },
      printPrescriptions() {
      const url = `${this.$route.params.patientID}/${this.$route.params.visitNo}`;

      window.open(
        `/medical-file/prescriptions/print/${url}`,
        "_blank",
        `PrescriptionsPrint`,
      );
    },

    },
    components: {

        'order-drugs': () => import('@/components/commons/medical-file/drugs-order/Form.vue'),
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <div class="w-full flex flex-wrap p-1 hide--print">
            <div class="flex-1">
                <span 
                    class="py-px px-3 font-medium 
                        bg-blue-800 text-white rounded text-xs mr-2">Inpatient</span>
                <span 
                    class="py-px px-3 font-medium 
                        bg-blue-400 text-white rounded text-xs mr-2">Outpatient</span>
                <span 
                    class="py-px px-3 font-medium 
                        bg-yellow-500 text-white rounded text-xs mr-2">Triage</span>
                <span 
                    class="py-px px-3 font-medium 
                        bg-green-500 text-white rounded text-xs mr-2">Discharge</span>
            </div>
            <div class="w-1/4">
                <button 
                    @click.prevent="orderDrugs = true"
                    class="btn-sm btn-info text-xs rounded">
                        <i class="fa fa-redo"></i> Order Drugs</button>
            </div>
            <order-drugs
                :patient="patient"
                :visit="visit" 
                :showModal="orderDrugs"
                :prescriptions="prescriptions.filter(pres => 
                    !pres.administrationStopped).map(pres => ({ ...pres, qtyOrdered: 0, }))"
                @closeModal="orderDrugs = false"
                @refresh="$emit('refresh')"
            />
        </div>
        <div class="w-full overflow-auto print:overflow-visible mx-h-30" 
            v-for="encounter in encounters" 
            :key="encounter.encounterId">
            <div class="p-1 w-full flex flex-wrap rounded-t-md"
                :class="{
                    'bg-blue-400': encounter.category == `OutPatient`,
                    'bg-blue-800' : encounter.category == `InPatient`,
                    'bg-yellow-500' : encounter.category == `Triage`,
                }"
                v-if="(prescriptions.length && 
                    prescriptions.filter(pres => encounter.encounterId==pres.encounterID).length) ||
                    (noneDrugTreatments.length && 
                    noneDrugTreatments.filter(nDT => nDT.encounterID==encounter.encounterId).length)">
                <div class="flex-1">
                    <h5 class="font-bold text-white text-sm">
                        Encounter #{{ encounter.encounterId }} Visit #{{encounter.visitNo}}</h5>
                </div>
                <div class="flex-1">
                    <router-link
                      v-if="
                            ($root.formatLowercase(encounter.userName) ==
                            $root.formatLowercase($root.username)) ||
                            $root.checkAuth('AdminEditMedicalFile') ? true : false
                          " 
                      :to="{
                        name: `med-f.visit.index`,
                        params: {
                          patientID: $route.params.patientID,
                          visitNo: $route.params.visitNo,
                        },
                        query: {
                          encounterID: encounter.encounterId,
                          from: $route.query.from,
                        },
                      }" 
                      class="btn-sm btn-warning text-xs text-white rounded hide--print">Edit Encounter</router-link>
                </div>
            </div>
            <div class="p-1 border w-full flex flex-wrap my-px" v-if="prescriptions.length && 
                    prescriptions.filter(pres => encounter.encounterId==pres.encounterID).length">
                <div class="md:w-1/5 w-1/4">
                    <h5 class="font-bold text-lg">Prescriptions</h5>
                </div>
                <div class="md:w-4/5 w-3/4">
                    <table class="table">
                        <thead class="text-sm bg-gray-200">
                            <tr>
                                <th class="p-tiny">Date</th>
                                <th class="p-tiny">Drug</th>
                                <th class="p-tiny">Prescription</th>
                                <th class="p-tiny">Req By</th>
                                <th class="p-tiny">Qty</th>
                                <th class="p-tiny">Status</th>
                                <th class="p-tiny">Action</th>
                            </tr>
                        </thead>
                        <tbody class="text-xs bg-gray-100">
                            <tr v-for="(prescription,idx) in 
                                    prescriptions.filter(pres => 
                                        encounter.encounterId == pres.encounterID)" 
                                :key="idx">
                                <td class="p-tiny">{{ prescription.date | dateFormat }}</td>
                                <td class="p-tiny">{{ prescription.drug }}</td>
                                <td class="p-tiny">{{ prescription.description }}</td>
                                <td class="p-tiny">{{ prescription.requested_By }}</td>
                                <td class="p-tiny">
                                    <h5 class="text-xs">Processed: {{ prescription.administeredQty }}</h5>
                                    <h5 class="text-xs">Issued: {{ prescription.issuedQty }}</h5>
                                    <h5 class="text-xs">Administered: {{ prescription.administeredQty }}</h5>
                                    <h5 class="text-xs">On Trolley: 
                                        {{ prescription.notAdministeredQty }}</h5>
                                </td>
                                <td class="p-tiny">
                                    <h5 class="text-xs">
                                        {{ 
                                            prescription.administeredQty 
                                                && 
                                            !prescription.administrationStopped 
                                                ? 
                                                `Administering` 
                                                : 
                                                `` 
                                        }}
                                    </h5>
                                    <h5 class="text-xs">
                                        {{ 
                                            prescription.administrationStopped 
                                                ? 
                                                `Admin Stopped` 
                                                : 
                                                `` 
                                        }}
                                    </h5>
                                    <h5 class="text-xs">
                                        {{ prescription.isProcessed && !prescription.issuedQty 
                                            ? `Awaiting Issue` 
                                            : ``
                                        }}
                                    </h5>
                                    <h5 class="text-xs">
                                        {{ prescription.isProcessed 
                                            && prescription.issuedQty 
                                            && !prescription.administeredQty
                                            && !prescription.administrationStopped
                                            ? `Awaiting Admn` 
                                            : ``
                                        }}
                                    </h5>
                                    <h5 class="text-xs">
                                        {{ !prescription.isProcessed &&!prescription.isSubtituted 
                                            ? `Awaiting Processing` 
                                            : ``
                                        }} 
                                    </h5> <h5 class="text-xs">
                                        {{ prescription.isSubtituted 
                                            ? `Subtituted By :`+prescription.substituteItemName
                                            : ``
                                        }} 
                                    </h5>
                                </td>
                                <td class="p-tiny">
                                    <tail-action-buttons action="Action">
                                        <template v-slot:buttons>
                                            <!-- <button class="w-24 btn-sm btn-danger text-xs border-b">
                                                <i class="fa fa-times"></i> Stop Issue
                                            </button> -->
                                            <button 
                                                @click.prevent="saveStopAdmin(prescription)"
                                                class="w-24 btn-sm btn-warning text-xs border-b">
                                                <i class="fa fa-ban"></i> Stop Admn
                                            </button>
                                        </template>
                                    </tail-action-buttons>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="w-full border flex flex-wrap my-px" 
                v-if="noneDrugTreatments.length && 
                    noneDrugTreatments.filter(nDT => nDT.encounterID==encounter.encounterId).length">
                <div class="md:w-1/5 w-1/4 p-1">
                    <h5 class="font-bold text-lg">None Drug Treatment</h5>
                </div>
                <div class="md:w-4/5 w-3/4 p-1">
                    <div class="my-px" 
                        v-for="noneDrugTreatment in 
                            noneDrugTreatments.filter(nDT => nDT.encounterID==encounter.encounterId)" 
                        :key="noneDrugTreatment.id">
                        <span v-html="noneDrugTreatment.description"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full p-1 text-right">
            <button 
                @click.prevent="printTodaysPrescription"
                class="btn-sm btn-info text-xs mr-8">
                    <i class="fa fa-print"></i> Print Today's Orders</button>
            <button 
                @click.prevent="printPrescriptions"
                class="btn-sm btn-primary text-xs">
                    <i class="fa fa-print"></i> Print Prescriptions</button>
        </div>
    </div>
</template>
<style scoped>
    @media print {
        .hide--print {
            display: none;
            max-height: none;
        }
        .mx-h-30 {
            max-height:none;
        }
    }
    .mx-h-30 {
        max-height:24rem;
    }
</style>
